import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';
import { useTheme } from '~/lib/providers/theme-provider';
import { cn } from '~/lib/utils';

export const ThemePicker: React.FC<{ className?: string }> = ({
  className,
}) => {
  const { theme, setTheme } = useTheme();

  return (
    <ThemeSwitch
      checked={theme === 'light'}
      disabled={false}
      onCheckedChange={(dark) => setTheme(dark ? 'light' : 'dark')}
      className={className}
    />
  );
};

export const ThemeSwitch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    className?: string;
  }
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'group flex h-[30px] w-[54px] shrink-0 cursor-pointer flex-row items-center rounded-full border p-0.5 transition-all disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-black data-[state=unchecked]:border-white',
      className,
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none h-6 w-6 rounded-full bg-black transition-all data-[state=checked]:translate-x-[24px] data-[state=unchecked]:translate-x-0 data-[state=unchecked]:bg-white',
      )}>
      {/* Moon */}
      <div className="opacity-100 transition-all duration-300 ease-in-out group-data-[state=checked]:opacity-0">
        <div className="absolute inset-0 origin-center rotate-0 scale-100 overflow-clip rounded-full p-1 transition-all duration-700 ease-in-out group-data-[state=checked]:rotate-90 group-data-[state=checked]:scale-0">
          <div className="size-full rounded-full bg-black" />
          <div className="absolute right-0 top-0 size-[14px] rounded-full bg-white" />
        </div>
      </div>

      {/* Sun */}
      <div className="opacity-0 transition-all duration-300 ease-in-out group-data-[state=checked]:opacity-100">
        <div className="absolute inset-0 -rotate-[350deg] scale-0 overflow-clip rounded-full p-[7px] transition-all duration-700 ease-in-out group-data-[state=checked]:rotate-0 group-data-[state=checked]:scale-100">
          <div className="size-full rounded-full bg-white" />
          {Array.from({ length: 8 }).map((_, index) => (
            <div
              key={index}
              style={{ transform: `translateX(-50%) rotate(${index * 45}deg)` }}
              className="absolute left-[50%] top-0 h-full -translate-x-[50%] pt-[3px]">
              <div className="h-[2.5px] w-[1.5px] bg-white" />
            </div>
          ))}
        </div>
      </div>
    </SwitchPrimitives.Thumb>
  </SwitchPrimitives.Root>
));
ThemeSwitch.displayName = SwitchPrimitives.Root.displayName;
